var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper",attrs:{"id":"app"}},[_c('div',{staticClass:"app-inner"},[_c('HeaderView'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('FooterView')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }